import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import _ from 'lodash';
import { useMemo } from 'react';

import { useCommonLookupLazy } from '@/hooks/useCommonLookupLazy';
import { getFriendlyId } from '@/utils/friendlyId';

import { conformanceRatingFromResults } from '../calculateConformanceRating';
import { latestResultValueFromData } from '../latestResultValueFromData';
import type { IndicatorFlatFields, IndicatorTableFields } from './types';

export const useLabelledFields = (
  records: IndicatorFlatFields[] | undefined
) => {
  const { getLabel: getConformanceLabel } = useRating(
    'indicator_conformance_status'
  );
  const { getByValue: getCommonLookupByValue } = useCommonLookupLazy();

  return useMemo<IndicatorTableFields[] | undefined>(() => {
    return records?.map((d) => {
      return {
        ...d,
        LatestResultValue: latestResultValueFromData(d) || '-',
        LatestResultDate: d.orderedResults[0]?.ResultDate || '-',
        Conformance: conformanceRatingFromResults(d),
        ConformanceLabelled: getConformanceLabel(
          conformanceRatingFromResults(d)
        ),
        TestFrequencyLabelled:
          getCommonLookupByValue('frequency', d.schedule?.Frequency)?.label ??
          '-',
        SequentialIdLabel: d.SequentialId
          ? getFriendlyId(Parent_Type_Enum.Indicator, d.SequentialId)
          : '',
      };
    });
  }, [records, getConformanceLabel, getCommonLookupByValue]);
};
